export enum CommentComposerDataEventObject {
  COMMENT_SEND = 'comment_send',
}

export enum MessageComposerDataEventObject {
  AI_COMPOSE_V2 = 'ai_compose_v2',
  FLOATING_TOOLBAR = 'floating_toolbar',
  SLACK_MENTIONS = 'slack_mentions',
}
